var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6138 17.8743L22.6187 17.8716H22.6091L22.5002 11H11.3096H0.0098503V17.8716H0.000244141L0.00515892 17.8743L0.000244141 17.877H0.0098503L5.65492 20.9359L11.3096 24.0001L16.964 20.9359L22.6091 17.877H22.6187L22.6138 17.8743Z",
    fill: "#FF6913"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6136 6.12578L22.6185 6.12332H22.6089L16.9638 3.06423L11.3093 0L5.65467 3.06423L0.00960615 6.12332H0L0.00491478 6.12578L0 6.12847V11H5.5H11H16.9638H22.5L22.6089 6.12847H22.6185L22.6136 6.12578Z",
    fill: "#F36D24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6136 6.12578L22.6185 6.12332H22.6089L16.9638 3.06423L11.3093 0L5.65467 3.06423L0.00960615 6.12332H0L0.00491478 6.12578L0 6.12847V11H5.5H11H16.9638H22.5L22.6089 6.12847H22.6185L22.6136 6.12578Z",
    fill: "#FF9F68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.6ab7d45e0294a7278ce1abd89664fe32.svg";
export { ForwardRef as ReactComponent };